/**
 * High-frequency or non-actionable event-bus messages excluded from durable
 * telemetry. Matches the Unity telemetry capture denylist.
 */
export const TELEMETRY_EVENT_DENYLIST = new Set<string>([
  "update_scene",
  "edit_measurement",
  "edit_annotation",
  "grabtool_operation",
  "bulk_update_entitysnapshot",
  "update_scene_tr",
  "update_scene_transform",
  "tool_action_response",
  "qos_data",
  "change_selection",
  "update_material",
  "update_mediatile",
  "sketch_uploaded",
  "participant_transform",
  "remote_rotation",
  "heartbeat",
  "shared_state_snapshot",
  "update_thumbnail",
  "change_battery_level",
  "easteregg_spawn",
  "easteregg_explosion",
  "pubsub_action",
  "prototype_custom",
  "animation_info",
]);
